import { List } from '@kerfjs/ui/list';
import { Text } from '@kerfjs/ui/text';
import { TextField } from '@kerfjs/ui/text-field';
import { type SafeHtml } from 'kerfjs';

import { DEFAULT_VERDICT_THRESHOLDS, type VerdictThresholds } from '../../../shared/verdict-thresholds.js';
import { num } from './settings-value.js';

const FIELDS: readonly { key: keyof VerdictThresholds; label: string }[] = [
  { key: 'fairPct', label: 'Fair Within' },
  { key: 'slightlyHighPct', label: 'Slightly-High Up To' },
  { key: 'highPct', label: 'High Up To' },
  { key: 'belowMarketPct', label: 'Below-Market Under' },
  { key: 'importPreferenceMarginPct', label: 'Prefer Import Margin' },
];

/**
 * Verdict threshold percentages versus the benchmark midpoint. Each field shows
 * the org's effective value (the server fills unset ones with the FR-3.22
 * defaults) and names its default as a hint (HS2-GR2Q4V).
 */
export function VerdictThresholdsView({ thresholds }: { thresholds: Record<string, unknown> }): SafeHtml {
  return (
    <List gap="m" controlInsets="rl">
      <Text tone="quiet" size="compact">
        Percent versus the benchmark midpoint.
      </Text>
      {FIELDS.map(({ key, label }) => (
        <TextField
          name={`t_${key}`}
          label={label}
          type="number"
          hint={`Default ${String(DEFAULT_VERDICT_THRESHOLDS[key])}%`}
          value={num(thresholds[key] ?? DEFAULT_VERDICT_THRESHOLDS[key])}
        />
      ))}
    </List>
  );
}
